import { ComposeViewState, ComposeControl } from 'owa-mail-compose-store';
import { action } from 'satcheljs/lib/legacy';

export default action('updateLastFocusedControl')(function updateLastFocusedControl(
    viewState: ComposeViewState,
    composeControl: ComposeControl
) {
    viewState.lastFocusedControl = composeControl;
});
